import React from 'react'

// import '../scss/Spinner.css';

export default () =>
    <div className="Spinner">
        {/*<img src={logo} alt="spinner" />*/}
        {/*<span className="loading" />*/}
    </div>